module.exports = __webpack_public_path__ + "img/3Dian5_5.53d67d30.png";